export const confirmBatchModalContent = {
  default: {
    single: {
      heading: 'Please double-check the batch you are selecting.',
      subheading: "You'll stay in this batch throughout your learning journey.",
    },
    multiple: {
      heading: 'Please double-check the batches you are selecting.',
      subheading:
        "You'll stay in these batches throughout your learning journey.",
    },
  },
  ongoing: {
    mixedOngoing: (batchName: string, completedSessions: number) => ({
      heading: `One of your batches has already started — Join Now And Get ${completedSessions} Catch-up Classes`,
      description: `${batchName} has already completed ${completedSessions} classes, you will be provided ${completedSessions} catch up classes to cover them`,
    }),
    singleOngoing: (batchName: string, completedSessions: number) => ({
      heading: `Join Now And Get ${completedSessions} Catch-up Classes`,
      description: `${batchName} has already completed ${completedSessions} classes, you will be provided ${completedSessions} catch up classes to cover them`,
    }),
  },
  voucherSubheading: (voucherLabel: string) =>
    `💰 Get a ${voucherLabel} voucher`,
  voucherFooter: (voucherLabel: string) =>
    `You are also eligible for a ${voucherLabel} cashback voucher, which will be processed after successfully completing 10 sessions in the selected batch.`,
  tncLabel: '*T&C apply',
  tncUrl: 'https://bhanzu.com/terms-and-conditions?product=home',
} as const;
